import { createContext, ReactNode, useContext, useState } from "react"

type MembershipGridContextType = {
  mode: "standard" | "premium"
  totalLevels: number
}

export const MembershipGridContext = createContext<MembershipGridContextType | undefined>(undefined)

export const useMembershipGridContext = () => {
  const context = useContext(MembershipGridContext)
  if (context === undefined) {
    throw new Error("useMembershipGridContext must be used within a MembershipGridContext.Provider")
  }
  return context
}
